import React from "react";
import { Alert } from "services/Alert";

import { canIMoveNumbersToAnyTrunk } from "utils";

import ChangeSupplierRateModal from "./Modals/AllocateNumbersModal/ChangeSupplierRateModal";
import ChangeRateModal from "./Modals/AllocateNumbersModal/ChangeRateModal";
import ChangeBillingTypeModal from "../../ChangeBillingTypeModal";
import DeletePrefixesModal from "../../DeletePrefixesModal";
import MoveNumbersModal from "../../MoveNumbersModal";
import RevokeNumbersModal from "../../RevokeNumbersModal";
import SetActiveModal from "../../SetActiveModal";
import SetIvrModal from "../../SetIvrModal";
import SetLimitModal from "../../SetLimitModal";
import ModifyGroupModal from "../ModifyGroupModal";
import UploadGanNumbersModal from "../../UploadGanNumbersModal/UploadGanNumbersModal";
import RemoveGroupModal from "../RemoveGroupModal";
import { MODALS } from "../Store/ModalsReducer";

const ModalsHost = ({
    opened,
    payload,
    closeModal,
    openModal,
    service,
    responsiveTarget,
    acc_key,
    getInitialValues,
    sp_key,
    account_name,
    updateItems,
    getTrunks,
    getDataForChangeRate,
    trunk_id,
    selectedItems,
    getDataForChangeSupplierRate,
    getSelectedNumbersCount,
    trunks,
    currentTrunk,
    raterc_list,
    ivr_list,
    allocatedNumbers,
    suppliersPrefixList,
    createTrafficLimit,
    modifyTrafficLimit,
    removeTrafficLimit,
    currentSupplier,
    getSupplierPrefixes,
    currentDisplay,
    currencyList,
    paymentTermsList,
    showReasonHandler,
}) => {
    return (
        <>
            {opened[MODALS.changeRate] &&
                <ChangeRateModal
                    service={service}
                    subDestinationsList={payload.currentSubDestinationsList}
                    target={responsiveTarget}
                    targetPrice={{ account_id: acc_key }}
                    initialValues={getInitialValues()}
                    sp_key={sp_key}
                    account_name={account_name}
                    update={() => {
                        getTrunks(true);
                        updateItems();
                    }}
                    activeTrunk={currentTrunk}
                    getData={getDataForChangeRate}
                    onClose={() => {
                        closeModal(MODALS.changeRate);
                    }}
                />
            }

            {opened[MODALS.changeSupplierRate] &&
                <ChangeSupplierRateModal
                    trunk_id={trunk_id}
                    targetPrice={{ account_id: acc_key }}
                    initialValues={getInitialValues()}
                    prefixKeyList={selectedItems}
                    sp_key={sp_key}
                    account_name={account_name}
                    update={() => {
                        getTrunks(true);
                        updateItems();
                    }}
                    getData={getDataForChangeSupplierRate}
                    onClose={() => {
                        closeModal(MODALS.changeSupplierRate);
                    }}
                />
            }

            {opened[MODALS.revoke] &&
                <RevokeNumbersModal
                    service={service}
                    target={responsiveTarget}
                    initialValues={getInitialValues()}
                    getCount={getSelectedNumbersCount}
                    update={() => {
                        getTrunks(true);
                        updateItems();
                    }}
                    onClose={() => closeModal(MODALS.revoke)}
                />
            }

            {opened[MODALS.move] &&
                <MoveNumbersModal
                    service={service}
                    target={responsiveTarget}
                    trunks={trunks.filter((trunk) => canIMoveNumbersToAnyTrunk(currentTrunk, trunk))}
                    initialValues={getInitialValues()}
                    getCount={getSelectedNumbersCount}
                    update={() => {
                        getTrunks(true);
                        updateItems();
                    }}
                    onClose={() => closeModal(MODALS.move)}
                />
            }

            {opened[MODALS.changeBT] &&
                <ChangeBillingTypeModal
                    service={service}
                    target={{ trunk_id }}
                    raterc_list={raterc_list}
                    initialValues={getInitialValues()}
                    getCount={getSelectedNumbersCount}
                    update={() => {
                        getTrunks(true);
                        updateItems();
                    }}
                    onClose={() => closeModal(MODALS.changeBT)}
                />
            }

            {opened[MODALS.ivr] &&
                <SetIvrModal
                    service={service}
                    target={responsiveTarget}
                    ivr_list={ivr_list}
                    initialValues={getInitialValues()}
                    allocatedNumbers={allocatedNumbers}
                    getCount={getSelectedNumbersCount}
                    update={() => {
                        getTrunks(true);
                        updateItems();
                    }}
                    onClose={() => closeModal(MODALS.ivr)}
                />
            }

            {opened[MODALS.deletePrefixes] &&
                <DeletePrefixesModal
                    show={opened[MODALS.deletePrefixes]}
                    initialValues={getInitialValues()}
                    prefixKeyList={selectedItems}
                    trunk_id={trunk_id}
                    update={() => {
                        getTrunks(true);
                        updateItems();
                    }}
                    onClose={() => {
                        closeModal(MODALS.deletePrefixes);
                    }}
                />
            }

            {opened[MODALS.setActive] &&
                <SetActiveModal
                    show={opened[MODALS.setActive]}
                    initialValues={getInitialValues()}
                    prefixKeyList={selectedItems}
                    trunk_id={trunk_id}
                    update={() => {
                        getTrunks(true);
                        updateItems();
                    }}
                    onClose={() => {
                        closeModal(MODALS.setActive);
                    }}
                    status={payload.activeStatus}
                />
            }

            {opened[MODALS.setLimit] &&
                <SetLimitModal
                    prefixList={suppliersPrefixList}
                    createTrafficLimit={createTrafficLimit}
                    modifyTrafficLimit={modifyTrafficLimit}
                    removeTrafficLimit={removeTrafficLimit}
                    initialValues={getInitialValues()}
                    getCount={getSelectedNumbersCount}
                    prefixKeyList={selectedItems}
                    supplierId={currentSupplier?.supplier_id}
                    getSupplierPrefixes={getSupplierPrefixes}
                    trunkId={trunk_id}
                    update={() => {
                        updateItems();
                    }}
                    updateCurrentPrefixes={() => {
                        updateItems();
                    }}
                    isGanNumbers={currentDisplay === "numbers"}
                    onClose={() => {
                        closeModal(MODALS.setLimit);
                    }}
                />
            }

            {opened[MODALS.modifyGroup] &&
                <ModifyGroupModal
                    show={opened[MODALS.modifyGroup]}
                    selectedItems={payload.selectedGroupData}
                    currentGroupData={payload.selectedGroupData}
                    service={service}
                    currencyList={currencyList}
                    paymentTermsList={paymentTermsList}
                    onSuccess={() => {
                        Alert.success(`GAN Group ${payload.selectedGroupData?.name || ""} was modified`);
                        updateItems();
                        closeModal(MODALS.modifyGroup);
                    }}
                    onClose={() => {
                        closeModal(MODALS.modifyGroup);
                    }}
                />
            }

            {opened[MODALS.uploadGan] &&
                <UploadGanNumbersModal
                    show={opened[MODALS.uploadGan]}
                    service={service}
                    isUploadToGroup
                    selectedItems={payload.selectedGroupData}
                    onSuccess={() => {
                        updateItems();
                        closeModal(MODALS.uploadGan);
                    }}
                    onClose={() => {
                        closeModal(MODALS.uploadGan);
                    }}
                />
            }

            {opened[MODALS.removeGroup] &&
                <RemoveGroupModal
                    show={opened[MODALS.removeGroup]}
                    selectedItems={payload.selectedGroupData}
                    onClose={() => {
                        closeModal(MODALS.removeGroup);
                    }}
                    onSuccess={() => {
                        updateItems();
                        closeModal(MODALS.removeGroup);
                        Alert.success("The GAN group was deleted");
                    }}
                    showReasonHandler={showReasonHandler}
                />
            }
        </>
    );
};

export default ModalsHost;
